import { Alert, Box, Button, TextField } from '@mui/material';
import { useState } from 'react';
import AuthPageLayout from './AuthPageLayout';
import { requestPasswordReset } from './LoginUtils';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError(null);
        setMessage(null);
        setSubmitting(true);
        try {
            const result = await requestPasswordReset(email);
            setMessage(result.message);
        } catch (err) {
            setError(err.message);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <AuthPageLayout
            title="Reset your password"
            subtitle="Enter your account email and we will send a reset link if an account exists."
            footerLink={{ to: '/mycases', label: 'Back to sign in' }}
        >
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {message && <Alert severity="info" sx={{ mb: 2 }}>{message}</Alert>}
            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    fullWidth
                />
                <Button type="submit" variant="contained" disabled={submitting}>
                    {submitting ? 'Sending…' : 'Send reset link'}
                </Button>
            </Box>
        </AuthPageLayout>
    );
}
